import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button} from "react-bootstrap";
import "./cirlceMarker.css";
import peopleIcon from "./resources/people.svg";

const CircleMarker = (props) => {
        let percent = props.percent
        let angle = percent * 1.8
        angle = angle + "deg"

    //document.documentElement.style.setProperty('--per',angle);

        let fill = "f" +Math.round(percent / 5) * 5;

        if (fill >= 100 || percent >= 100){
            fill = "f100";
            percent = 100;
        }



    if (percent >= 0 && percent < 25){
        return (
            <div className={fill}>
                <div className="circle-wrap" style={{background: '#056b02' }} >
                    <div className="circle"  >
                        <div className="mask full" >
                            <div className="fill " style={{background: '#0b9b06'}} ></div>
                        </div>
                        <div className="mask half">
                            <div className="fill" style={{background: '#0b9b06' }} ></div>
                        </div>
                        <div className="inside-circle">
                            <div className="svg">
                                <img src={peopleIcon}  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (percent >= 25 && percent < 50){
        return (
            <div className={fill}>
                <div className="circle-wrap" style={{background: '#9a8000' }} >
                    <div className="circle"  >
                        <div className="mask full" >
                            <div className="fill " style={{background: '#d7ba00'}} ></div>
                        </div>
                        <div className="mask half">
                            <div className="fill" style={{background: '#d7ba00' }} ></div>
                        </div>
                        <div className="inside-circle">
                            <div className="svg">
                                <img src={peopleIcon}  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (percent >= 50 && percent < 75){
        return (
            <div className={fill}>
                <div className="circle-wrap" style={{background: '#723c00' }} >
                    <div className="circle"  >
                        <div className="mask full" >
                            <div className="fill " style={{background: '#d36200'}} ></div>
                        </div>
                        <div className="mask half">
                            <div className="fill" style={{background: '#d36200' }} ></div>
                        </div>
                        <div className="inside-circle">
                            <div className="svg">
                                <img src={peopleIcon}  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (percent >= 75){
        return (
            <div className={fill}>
                <div className="circle-wrap" style={{background: '#540000' }} >
                    <div className="circle"  >
                        <div className="mask full" >
                            <div className="fill " style={{background: '#c20000'}} ></div>
                        </div>
                        <div className="mask half">
                            <div className="fill" style={{background: '#c20000' }} ></div>
                        </div>
                        <div className="inside-circle">
                            <div className="svg">
                                <img src={peopleIcon}  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className={fill}>
                <div className="circle-wrap" style={{background: '#575757', height: '34px', width: '34px', marginTop: '0', marginLeft: '-0'}} >
                    <div className="circle" >
                        <div className="inside-circle" style={{height: '22px', width: '22px' }}>
                        </div>
                    </div>
                </div>
            </div>
        );
    }






};

export default CircleMarker;